import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type ExtendCCSvgProps = {
  className?: string
} & ComponentProps<'svg'>
export default function ExtendCCSvg(props: ExtendCCSvgProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ExtendCCSvg', className)}
      width="102"
      height="66"
      viewBox="0 0 102 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <g filter="url(#filter0_d_2156_37729)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.5777 57.9051C99.5769 60.2678 97.6618 62.1829 95.2991 62.1837L6.68629 62.2131C4.3214 62.2138 2.40409 60.2965 2.40487 57.9316L2.42231 5.30927C2.4231 2.9466 4.33822 1.03147 6.7009 1.03069L95.3137 1.00133C97.6786 1.00055 99.5959 2.91786 99.5951 5.28275L99.5777 57.9051Z"
          fill="url(#paint0_linear_2156_37729)"
        />
        <g clipPath="url(#clip0_2156_37729)">
          <path
            d="M53.213 39.9516L52.197 39.2479C51.487 38.7342 51.0102 37.9595 50.8717 37.0942C50.7331 36.2289 50.944 35.344 51.4581 34.6343L56.45 27.7248C57.167 26.7308 57.167 25.3894 56.45 24.3954L51.4669 17.5079C50.3945 16.0322 50.7214 13.9666 52.197 12.8942L53.2042 12.1685C53.9134 11.6507 54.8 11.4375 55.6671 11.5763C56.5342 11.715 57.31 12.1942 57.8222 12.9074L66.1435 24.4086C66.8602 25.393 66.8602 26.7272 66.1435 27.7116L57.8222 39.2127C57.3101 39.9234 56.536 40.4009 55.6711 40.5395C54.8061 40.6782 53.9216 40.4666 53.213 39.9516Z"
            fill="white"
          />
          <path
            d="M43.9021 50.1597L35.5808 38.6586C34.8634 37.6728 34.8634 36.3369 35.5808 35.3512L43.9021 23.8544C44.4157 23.1444 45.1905 22.6676 46.0558 22.5291C46.9211 22.3905 47.806 22.6014 48.5157 23.1155L49.5185 23.8544C50.988 24.9233 51.3199 26.9776 50.2618 28.4549L45.3271 35.2896C44.58 36.3241 44.58 37.7208 45.3271 38.7553L50.2618 45.5549C51.3288 47.0346 50.9963 49.0988 49.5185 50.1685L48.5157 50.8986C47.806 51.4127 46.9211 51.6236 46.0558 51.4851C45.1905 51.3465 44.4157 50.8697 43.9021 50.1597Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2156_37729"
          x="0.404907"
          y="0.00134277"
          width="101.19"
          height="65.2117"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2156_37729"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2156_37729"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2156_37729"
          x1="99.5966"
          y1="31.6072"
          x2="2.40345"
          y2="31.6072"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FCEB6" />
          <stop offset="1" stopColor="#619BF9" />
        </linearGradient>
        <clipPath id="clip0_2156_37729">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(30.8761 11.5349)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
